import { arrayToggle } from 'common/ArrayUtilities';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { SpiceTag } from 'src/shared/design-system/SpiceTagV2';
import { SpiceLevelMap, SpiceLevelOptions } from 'web-common/src/shared/Enums';
import { useTrackFilterChange } from '../hooks/useTrackFilterChange';
import { SECTION_TEXT, SPICE_LEVELS } from './consts';
import { Section } from './styles';
import { FilterProps } from './types';

interface SpiceLevelButtonProps {
  onClick: (spiceLeve: SpiceLevelOptions) => void;
  value?: SpiceLevelOptions[];
  showText?: boolean;
  selectLowerLevels?: boolean;
}

const SPICE_LEVEL_COPY = {
  [SpiceLevelOptions.NOT_SPICY]: 'No spice',
  [SpiceLevelOptions.MILD]: 'Mild spice',
  [SpiceLevelOptions.MEDIUM]: 'Med spice',
  [SpiceLevelOptions.HOT]: 'Hot spice',
};

export const SpiceLevelButtons: React.FC<SpiceLevelButtonProps> = ({
  onClick,
  value = [],
  showText = false,
  selectLowerLevels = false,
}) => {
  const index = SPICE_LEVELS.indexOf(value[0]);

  return (
    <Section.Wrapper>
      <Section.ButtonContainer>
        {SPICE_LEVELS.map((spiceLevel) => {
          const selected = selectLowerLevels ? SPICE_LEVELS.indexOf(spiceLevel) <= index : value.includes(spiceLevel);
          return (
            <div className='flex flex-col items-center gap-2' key={spiceLevel}>
              <Section.RoundButton key={spiceLevel} onClick={() => onClick(spiceLevel)} selected={selected}>
                <SpiceTag spiceLevel={SpiceLevelMap[spiceLevel]} />
              </Section.RoundButton>
              {showText && <span>{SPICE_LEVEL_COPY[spiceLevel]}</span>}
            </div>
          );
        })}
      </Section.ButtonContainer>
    </Section.Wrapper>
  );
};

export const SpiceLevel: React.FC<FilterProps> = ({ filters }) => {
  const { spiceLevelFilters, updateQueryParams } = filters;
  const { trackFilterChange } = useTrackFilterChange({ filters });

  const handleClick = useCallback(
    (spiceLevel: SpiceLevelOptions) => {
      const updates = { [QueryParams.SPICE_LEVEL_FILTER]: arrayToggle(spiceLevelFilters, spiceLevel) };
      updateQueryParams(updates);
      trackFilterChange(updates);
    },
    [updateQueryParams, spiceLevelFilters, trackFilterChange]
  );

  return (
    <Section.Container>
      <Section.Header>{SECTION_TEXT.SPICE.HEADER}</Section.Header>
      <SpiceLevelButtons onClick={handleClick} value={spiceLevelFilters} />
    </Section.Container>
  );
};
